import { createContext, useContext, useMemo, useState } from 'react';

const AuthContext = createContext(null);

function decodeTokenPayload(token) {
  if (!token) {
    return null;
  }

  try {
    const [, payload = ''] = token.split('.');
    if (!payload) {
      return null;
    }

    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
    return JSON.parse(window.atob(padded));
  } catch {
    return null;
  }
}

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const tokenPayload = useMemo(() => decodeTokenPayload(token), [token]);
  const role = tokenPayload?.role || tokenPayload?.user_role || null;

  const value = useMemo(
    () => ({
      token,
      role,
      user: tokenPayload,
      isAuthenticated: Boolean(token),
      login: (nextToken) => {
        localStorage.setItem('token', nextToken);
        setToken(nextToken);
      },
      logout: () => {
        localStorage.removeItem('token');
        setToken(null);
      },
    }),
    [role, token, tokenPayload]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used inside AuthProvider');
  }
  return ctx;
}
